import { render, staticRenderFns } from "./billList.vue?vue&type=template&id=0c84185c&scoped=true"
import script from "./billList.vue?vue&type=script&lang=js"
export * from "./billList.vue?vue&type=script&lang=js"
import style0 from "./billList.vue?vue&type=style&index=0&id=0c84185c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c84185c",
  null
  
)

export default component.exports